import { useContext, useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import defaultImage from "../assets/images/placeholder.jpg";
import DataContext from "../contexts/DataContext";
import { environment } from "../global/environment";

function Hero() {
  const [image, setImage] = useState(defaultImage);
  const [isInternalUser] = useState(window.isInternalUser ?? {});
  const { candidate } = useContext(DataContext);
  const hasCurriculumVitae = candidate?.cvName;
  const { getValues, setValue } = useFormContext();

  const handleFileChange = (file) => {
    //Update value
    setValue("picture_file", file);
    //Update state to display it
    setImage(URL.createObjectURL(file));
  };

  useEffect(() => {
    setImage(
      getValues("picture_name")
        ? `${environment.imagesUrl}/images/${getValues("picture_name")}`
        : defaultImage
    );
  }, []);

  return (
    <div className="c-profile-hero o-section">
      <div className="c-profile-hero__wrapper o-wrapper">
        <h2 className="u-hidden-for-seo">Mi Perfil</h2>
        <div className="c-profile-hero__image">
          <div className="c-profile-hero__pic">
            {image && (
              <picture className="c-pic c-pic--abs">
                <img className="c-pic__img" src={image} alt="Foto de perfil" />
              </picture>
            )}
          </div>

          {!isInternalUser && <form action="#" className="c-profile-hero__image-change">
            <label
              className="c-profile-hero__image-change-label"
              htmlFor="profile-pic"
            >
              <input
                type="file"
                id="profile-pic"
                name="profile-pic"
                className="c-profile-hero__image-change-input"
                accept="image/png, image/jpeg"
                onChange={(e) => handleFileChange(e.target.files[0])}
              />
              <span className="c-profile-hero__image-change-btn u-tap-size">
                <span className="c-profile-hero__image-change-icon icon-edit"></span>
              </span>
            </label>
          </form>}
        </div>

        <div className="c-profile-hero__intro">
          <p className="c-profile-hero__title">
            ¡Bienvenido {candidate?.name} {candidate?.lastName}!
          </p>

          <p className="c-profile-hero__mail">{candidate?.email}</p>
          {/* Para el colaborador interno el CV es opcional, así que no se le
              reclama: el aviso en rojo hacía pensar que la postulación no había
              quedado registrada. */}
          {!hasCurriculumVitae && !window.isInternalUser && (
            <p className="curriculum__empty">
              <span className="c-form__hint-icon icon-empty"></span>No tienes
              ningún archivo cargado en tu perfil, debes cargar tu Currículum
              Vitae.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
export default Hero;
